import { Crown, LockKeyhole } from 'lucide-react'
import { Link } from 'react-router-dom'

function VipLockCard({
  title = 'VIP 专属',
  description = '这部分可生成更详细建议，开通 VIP 后可查看。',
  actionLabel = '查看 VIP 权益',
  compact = false,
}) {
  return (
    <article className={`vip-lock-card${compact ? ' is-compact' : ''}`}>
      <span className="vip-lock-icon"><LockKeyhole size={18} /></span>
      <div>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <Link className="secondary-button" to="/vip">
        <Crown size={16} />
        {actionLabel}
      </Link>
    </article>
  )
}

export default VipLockCard
